import React from 'react'

const MyQueueIcon = () =>
    <svg width="22" height="23" viewBox="-3 -2 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 2V16H2V2H16ZM17.1 0H0.9C0.4 0 0 0.4 0 0.9V17.1C0 17.5 0.4 18 0.9 18H17.1C17.5 18 18 17.5 18 17.1V0.9C18 0.4 17.5 0 17.1 0ZM8 4H14V6H8V4ZM8 8H14V10H8V8ZM8 12H14V14H8V12ZM4 4H6V6H4V4ZM4 8H6V10H4V8ZM4 12H6V14H4V12Z" fill="white" />
    </svg>

export default MyQueueIcon;